var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useState } from 'react';
import KB from '@kb/global-context';
import Button, { ButtonDisplayType, IconSymbol } from '@ocp/button';
import DropDown, { MenuAlignment } from '@ocp/dropdown';
import { useActions, useButtons } from '../../hooks/index';
import { useContentActionsQuery } from '../../queries/index';
import ComparisonNotification from '../ComparisonNotification';
import DrawerList from './DrawerList';
import DropDownList from './DropDownList';
const BurgerButton = ({ classNameId, classPk, deviceType, panelMode, hiddenButtons, shownButtons, }) => {
    var _a, _b;
    const [comparisonNotificationVisible, setComparisonNotificationVisible] = useState(false);
    const [fetch, { data, loading }] = useContentActionsQuery();
    const getActions = (cacheFirst = false) => {
        fetch({
            variables: {
                classNameId,
                classPk,
                deviceType,
                panelMode,
            },
            fetchPolicy: cacheFirst ? 'cache-first' : 'cache-and-network',
        });
    };
    const _c = (_a = data === null || data === void 0 ? void 0 : data.contentToolbarActions) !== null && _a !== void 0 ? _a : { actions: [] }, { actions: actionsData } = _c, buttonsData = __rest(_c, ["actions"]);
    const containerRef = useRef(null);
    const buttons = useButtons({
        classNameId,
        classPk,
        deviceType,
        panelMode,
    }, buttonsData, hiddenButtons, shownButtons, containerRef, () => getActions(), () => setComparisonNotificationVisible(true));
    const actions = useActions(classNameId, classPk, actionsData);
    const trigger = (React.createElement(Button, { displayType: ButtonDisplayType.Fourth, symbol: IconSymbol.KnowVerticalDots, disabled: loading, onClick: () => getActions(true) }));
    const items = [...actions, ...buttons]
        .sort((a, b) => a.order - b.order)
        .map((item) => ({
        title: item.title,
        icon: 'icon' in item ? item.icon : undefined,
        onClick: item.onClick,
        items: 'items' in item ? item.items : undefined,
    }));
    return (React.createElement("div", { ref: containerRef },
        KB.isMobile ? (React.createElement(DrawerList, { trigger: trigger, items: items })) : (React.createElement(DropDown, { alignmentPosition: MenuAlignment.BottomRight, trigger: trigger, closeOnClick: true },
            React.createElement(DropDownList, { items: items }))),
        React.createElement(ComparisonNotification, { classNameId: classNameId, classPk: classPk, comparisonPageUrl: (_b = buttonsData.addToComparisonListButton) === null || _b === void 0 ? void 0 : _b.comparisonPageUrl, visible: comparisonNotificationVisible, onClose: () => setComparisonNotificationVisible(false) })));
};
export default BurgerButton;
